import React, {useState, useRef} from 'react'
import Select, {PromptType} from '../../../../Prompt/Select/Select'
import styled from 'styled-components'
import {NavigationButtons} from '../../../../Navigation/NavigationButtons/NavigatonButtons'
import CalendarField from '../../../../Calendar/CalendarField/CalendarField'
import Selector from '../../../../Selector/Selector'
import {ErrorContainer} from '../../../../ErrorContainer'
import {_L, useLocaleState} from '../../../../../context/LocaleContext'

const EmployeeLeaving = ({move, setValue, onNext, onPrevious}) => {
  const [errors] = useState({})
  const parentContainer = useRef(null)
  const localeState = useLocaleState()
  const {moveEmployees, activeMoveEmployeeIndex} = move

  const employee = moveEmployees[activeMoveEmployeeIndex]

  const onSelectStartDate = startDate => {
    setValue({startDate: new Date(startDate)})
  }

  const onPromptChange = item => {
    setValue(item)
  }

  return (
    <Container ref={parentContainer}>
      <Selector
        onPromptChange={onPromptChange}
        render={(selectors, onChange) => (
          <StyledContent>
            <FieldContainer>
              <Select
                parentContainer={parentContainer}
                type={PromptType.EMPLOYEE}
                label={_L({key: 'Employee', localeState})}
                placeholder={_L({key: 'Select Employee', localeState})}
                onChange={onChange}
                value={employee.employee}
              />

              <ErrorContainer errorMessage={errors.employee} />

              <StyledFieldLabel>
                {_L({key: 'Date leaving', localeState})}
              </StyledFieldLabel>

              <CalendarField
                onSelect={onSelectStartDate}
                date={move.startDate.toISOString()}
                locale="en"
              />
            </FieldContainer>

            <FieldContainer>
              <StyledTitle>
                {_L({key: 'Space Leaving', localeState})}
              </StyledTitle>

              <Select
                parentContainer={parentContainer}
                type={PromptType.BUILDING}
                label={_L({key: 'Building', localeState})}
                placeholder={_L({key: 'Search Buildings', localeState})}
                onChange={onChange}
                value={employee.building}
              />
              <ErrorContainer errorMessage={errors.building} />
              <Select
                parentContainer={parentContainer}
                type={PromptType.FLOOR}
                label={_L({key: 'Floor', localeState})}
                placeholder={_L({key: 'Search Floors', localeState})}
                onChange={onChange}
                value={employee.floor}
              />
              <Select
                parentContainer={parentContainer}
                type={PromptType.ROOM}
                label={_L({key: 'Room', localeState})}
                placeholder={_L({key: 'Search Rooms', localeState})}
                onChange={onChange}
                value={employee.room}
              />
            </FieldContainer>
          </StyledContent>
        )}
      />

      <NavigationButtonContainer>
        <NavigationButtons onNextClick={onNext} onBackClick={onPrevious} />
      </NavigationButtonContainer>
    </Container>
  )
}

export default EmployeeLeaving

const Container = styled.div`
  width: 468px;
  position: relative;

  @media (max-width: 420px) {
    width: 100vw;
    height: calc(100vh - 110px);
    overflow-y: scroll;
    background-color: white;
    box-sizing: border-box;
  }
`

const FieldContainer = styled.div`
  padding: 34px 50px 2px 50px;
  width: 434px;

  @media (max-width: 420px) {
    width: 100%;
    padding: 18px 24px 8px 24px;
    box-sizing: border-box;
  }
`

const StyledTitle = styled.div`
  font-size: 18px;
  font-weight: normal;
  padding: 4px 0px 18px 0px;
`

const NavigationButtonContainer = styled.div`
  @media (max-width: 420px) {
    width: 100vw;
    height: 80px;
    background-color: white;
    position: fixed;
    bottom: 0;
    padding-top: 6px;
  }
`

const StyledContent = styled.div`
  margin-top: 14px;
  margin-bottom: 20px;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  background-color: #ffffff;
  padding: 2px 0 34px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 420px) {
    margin: 0;
    border-radius: 0;
    width: 100vw;
    padding: 6px 0 100px 0;
  }
`

const StyledFieldLabel = styled.div`
  color: #a4a9b7;
  font-size: 16px;
  font-weight: normal;
  padding: 8px 0px 2px 0px;
`
